var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligible2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3211 21.74C18.1211 21.72 17.8811 21.72 17.6611 21.74C12.9011 21.58 9.12109 17.68 9.12109 12.88C9.12109 7.98 13.0811 4 18.0011 4C22.9011 4 26.8811 7.98 26.8811 12.88C26.8611 17.68 23.0811 21.58 18.3211 21.74Z",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.8186 8C36.6986 8 39.8186 11.14 39.8186 15C39.8186 18.78 36.8186 21.86 33.0786 22C32.9186 21.98 32.7386 21.98 32.5586 22",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32141 29.12C3.48141 32.36 3.48141 37.64 8.32141 40.86C13.8214 44.54 22.8414 44.54 28.3414 40.86C33.1814 37.62 33.1814 32.34 28.3414 29.12C22.8614 25.46 13.8414 25.46 8.32141 29.12Z",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.6797 40C38.1197 39.7 39.4797 39.12 40.5997 38.26C43.7197 35.92 43.7197 32.06 40.5997 29.72C39.4997 28.88 38.1597 28.32 36.7397 28",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligible2);
export default __webpack_public_path__ + "static/media/eligible2.9103ca7eb9d1e2609e16ef744028576d.svg";
export { ForwardRef as ReactComponent };